exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.upload-modal{height:100%;width:100%;background:rgba(0,0,0,.5);position:fixed;padding-top:calc(50vh - 176px);padding-left:calc(50vw - 320px);z-index:20;animation:fadein .5s}@keyframes fadein{0%{opacity:0}to{opacity:1}}.upload-modal .multi-file-uploader{box-sizing:border-box;height:352px;width:640px;padding:25px 50px}.upload-modal .multi-file-uploader__container{border-width:3px}.upload-modal .multi-file-uploader__text{font-size:24px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/FileUploadModal/FileUploadModal.scss
// module id = 1706
// module chunks = 0